export default __webpack_public_path__ + "static/media/caution.5bc85043.jpg";